import { Check, Copy, ExternalLink } from 'lucide-preact';
import { useCallback, useState } from 'preact/compat';

import { Wrapper } from '@/components/wrapper/wrapper';

interface ShareLinkSectionProps {
  playgroundUrl: string;
}

export function ShareLinkSection({ playgroundUrl }: ShareLinkSectionProps) {
  const [isCopied, setIsCopied] = useState(false);

  const onCopyUrl = useCallback(async () => {
    if (!playgroundUrl) return;

    try {
      await navigator.clipboard.writeText(playgroundUrl);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy URL:', error);
    }
  }, [playgroundUrl]);

  const onOpenPlayground = useCallback(() => {
    if (!playgroundUrl) return;
    window.open(playgroundUrl, '_blank', 'noopener,noreferrer');
  }, [playgroundUrl]);

  return (
    <Wrapper title='Odkaz pro sdílení' defaultOpen>
      <div className='flex flex-col gap-3'>
        <p className='text-xs leading-relaxed text-[#1a1a1a]/70'>
          Sdílejte tento odkaz s kolegy nebo zákazníky pro testování chatbota.
          Chatbot je dostupný i bez registrace.
        </p>
        <div className='flex gap-2'>
          <div className='relative flex-1 rounded-2xl border border-[#e4e4e7] bg-white'>
            <input
              readOnly
              value={playgroundUrl}
              className='w-full select-all rounded-2xl px-4 py-2.5 text-xs text-[#1a1a1a] outline-none'
              onClick={e => (e.target as HTMLInputElement).select()}
            />
          </div>
          <button
            data-cta='web-input-copy-url-button'
            type='button'
            className='inline-flex shrink-0 items-center justify-center gap-2 rounded-2xl border border-[#e4e4e7] bg-white px-4 py-2.5 text-sm font-medium text-[#1a1a1a] transition-all hover:bg-[#f4f4f5] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#9c70ff]/50'
            onClick={onCopyUrl}
            title='Zkopírovat odkaz'
          >
            {isCopied ? (
              <Check className='size-4 text-[#22c55e]' />
            ) : (
              <Copy className='size-4' />
            )}
          </button>
          <button
            data-cta='web-input-open-playground-button'
            type='button'
            className='inline-flex shrink-0 items-center justify-center gap-2 rounded-2xl bg-[#9c70ff] px-4 py-2.5 text-sm font-medium text-white transition-all hover:bg-[#8a58ff] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#9c70ff]/50'
            onClick={onOpenPlayground}
            title='Otevřít v novém okně'
          >
            <ExternalLink className='size-4' />
          </button>
        </div>
      </div>
    </Wrapper>
  );
}
